import { Supplier } from '@/generated/gql/graphql';

export enum SupplierDataGridField {
  NAME = 'name',
  EXTERNAL_ID = 'externalId',
  EMPLOYEE_COUNT = 'employeeCount',
  INDUSTRY = 'industry',
  LEGAL_TYPE = 'legalType',
  RELATIONSHIP = 'relationship',
  PREQUALIFICATION_LEVEL = 'prequalificationLevel',
  PREQUALIFICATION_TRADES = 'prequalificationTrades',
  LOCATION_GROUP_LIST = 'locationGroupList',
  LOCATION = 'location',
  REPRESENTATIVE_COUNT = 'representativeCount',
  TAG_COUNT = 'tagCount',
  ACTIVE_CONTRACT_COUNT = 'activeContractCount',
  QUOTATION_COUNT = 'quotationCount',
  QUOTATION_SUCCESS_RATE = 'quotationSuccessRate',
  ORDERED_PRODUCT_COUNT = 'orderedProductCount',
  ORDERED_PRODUCT_IN_CATEGORY_COUNT = 'orderedProductInCategoryCount',
  ORDERED_SERVICE_COUNT = 'orderedServiceCount',
  ORDERED_SERVICE_IN_CATEGORY_COUNT = 'orderedServiceInCategoryCount',
  ORDER_LAST_DATE = 'orderLastDate',
  ORDER_VOLUME_YEAR = 'orderVolumeYear',
  ORDER_COUNT_YEAR = 'orderCountYear',
  ORDER_VOLUME = 'orderVolume',
  ORDER_COUNT = 'orderCount',
  ORDER_VOLUME_SHARE = 'orderVolumeShare',
  ORDER_VOLUME_SHARE_YEAR = 'orderVolumeShareYear',
  ORDER_VOLUME_CUMULATIVE = 'orderVolumeCumulative',
  ORDER_VOLUME_CUMULATIVE_YEAR = 'orderVolumeCumulativeYear',
  REVENUE = 'revenue',
  EBIT = 'ebit',
  PE_RATIO = 'peRatio',
  SUPPLIER_PHONE = 'supplierPhone',
  SUPPLIER_FAX = 'supplierFax',
  SUPPLIER_EMAIL = 'supplierEmail',
  SUPPLIER_WEBSITE = 'supplierWebsite',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_GROUP_COUNT = 'commodityGroupCount',
  LINKS = 'links',
}

export enum SupplierDataGridColumnGroup {
  SUPPLIER = 'supplier',
  CONTRACT = 'contract',
  PRODUCT = 'product',
  SERVICE = 'service',
  ORDER = 'order',
  FINANCIAL = 'financial',
  CONTACT = 'contact',
}

export type SupplierDataGridRow = Supplier;
